/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import { ChannelFormDto } from '../widgets/ChannelForm';

type Props = {
  functionDelete?: any
  id?: string
}

const DeleteChannelModal: FC<Props> = ({ functionDelete, id }) => {

  return (
    <div className='modal fade' id='kt_modal_channel_delete' aria-hidden='true'>
      <div className='modal-dialog modal-l'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2>
                {LanguageHelp("Delete Channel")}
              </h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonDeleteDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
            <div>
              <div className='card-body border-top'>
                <div className='notice d-flex bg-light-danger rounded border-warning border border-dashed mb-6 p-6'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon-2tx svg-icon-danger me-4'
                  />

                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <div className='fs-6 text-gray-600'>
                        {LanguageHelp('Deleting this channel will cause the reports of the channel to be deleted as well.')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='text-center pt-0 pb-5'>
                <button type='button' className='btn btn-light me-3' data-bs-dismiss='modal'>
                  {LanguageHelp('Cancel')}
                </button>
                <button type='button' className='btn btn-danger' onClick={async () => await functionDelete(id)}>
                  {LanguageHelp('Delete')}
                </button>
              </div>
            </div>
          </div>

        </div></div>
    </div>
  )
}

export { DeleteChannelModal }
